module.exports = __webpack_public_path__ + "static/health-system-overview-aa3cd2cc2f7ef24576b15e9136982974.png";